<ng-content></ng-content>
<input type="file"
       #input
       class="visually-hidden"
       [attr.accept]="accept"
       [attr.id]="inputId"
       (change)="onChange($event)" />